import React, { useMemo, useCallback } from 'react'

import { useDialog } from '@galo-monitor/dialog'
import { useT } from '@galo-monitor/i18n'
import useGaloMonitorApi from '@galo-monitor/services/hooks/useGaloMonitorApi'
import DataTable from '@galo-monitor/web-components/DataTable'
import PesticideManufacturerModal from '@galo-monitor/web-containers/modals/root/PesticideManufacturerModal'
import { useRoutes } from '@galo-monitor/web-containers/routes/authenticated'

const Manufacturers = () => {
  const t = useT()
  const { createDialog } = useDialog()
  const { routes, getActionsBySlug } = useRoutes()

  const { data: manufacturers, mutate, isValidating } = useGaloMonitorApi('/admin/defensives-makers')

  const userActions = useMemo(
    () => getActionsBySlug(routes.pesticides.slug),
    [getActionsBySlug, routes.pesticides.slug]
  )

  const columns = useMemo(
    () => [
      {
        title: t('name'),
        field: 'name'
      }
    ],
    [t]
  )

  const onAddClick = useCallback(
    () => {
      createDialog({
        id: 'create-manufacturer',
        Component: PesticideManufacturerModal,
        props: {
          onSuccess: mutate
        }
      })
    },
    [createDialog, mutate]
  )

  const onEditClick = useCallback(
    (_, manufacturer) => {
      createDialog({
        id: 'edit-manufacturer',
        Component: PesticideManufacturerModal,
        props: {
          manufacturer,
          onSuccess: mutate
        }
      })
    },
    [createDialog, mutate]
  )

  return (
    <DataTable
      loading={ isValidating }
      data={ manufacturers || [] }
      columns={ columns }
      onAddClick={ userActions.write && onAddClick }
      onEditClick={ userActions.edit && onEditClick }
    />
  )
}

export default Manufacturers
